import Vapi from '@borisp/vuex-rest-api'
import { payloadToState } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    crons: [],
    cronsMetadata: {},
    cron: {},
    cronMetadata: {},
    cronRuns: [],
    cronRunsMetadata: {},
    cronRunLog: null
  }
})
  .get({
    action: 'getCronCode',
    property: 'cronCode',
    path: '/cron/info/get-security-code'
  })
  .get({
    action: 'getCrons',
    property: 'crons',
    queryParams: true,
    path: () => `/cron/list/`,
    onSuccess: payloadToState('crons')
  })
  .get({
    action: 'getCron',
    property: 'cron',
    path: ({ id }) => `/cron/detail/${id}`,
    onSuccess: payloadToState('cron')
  })
  .get({
    action: 'getCronRuns',
    property: 'cronRuns',
    path: ({ id }) => `/cron/list/cron-runs/${id}`,
    onSuccess: payloadToState('cronRuns')
  })
  .get({
    action: 'getCronRunLog',
    property: 'cronRunLog',
    path: ({ id, type }) => `/cron/show/${type}/${id}`
  })
  .get({
    action: 'downloadCronRunLog',
    path: ({ id, type }) => `/cron/download/${type}/${id}`
  })
  .post({
    action: 'runCron',
    path: ({ code, id }) => `/cron/run/${code}/${id}`
  })
  .post({
    action: 'unlockCron',
    path: ({ id }) => `/cron/unlock/${id}`
  })
  .put({
    action: 'updateCron',
    property: 'cron',
    path: ({ id }) => `cron/update/${id}`,
    onSuccess: payloadToState('cron')
  })
  .getStore()
